import React, { Component} from "react";
// Styles
import "./LevelView.scss";


// Components
import HeaderView from "components/HeaderView";
import Level from "views/Level/Level";

class LevelView extends Component {

  render() {
    return (
      <>
      <div className="level-view">
      <HeaderView/>
      <Level>
       </Level>
    </div>
      </>
    );
  }
}
export default LevelView;
